import {
  service
} from "../utils/service";
import {
  localPath
} from "./api.js";

// 查询总归属
export function pageStore(params) {
  return service({
    url: "/api" + "/demay/ssm/store/pageStore",
    method: "post",
    data: params
  });
}

// 查询用户（新）
export function staffPageByParent(data) {
  return service({
    url: "/api" + "/demay/ssm/staff/pageByParent",
    method: "post",
    data
  });
}

// 查询角色归属哪个门店
export function SysRoleStore(params) {
  return service({
    url: "/api" + "/demay/ssm/SysRoleStore/page",
    method: "post",
    data: params
  });
}

// 获取某门店参数
export function allStores(data){
  return service({
    url: "/api" + '/demay/ssm/storePara/list',
    method: "post",
    data
  })
}

// 获取超级密码验证码
export function getStoreId(data){
  return service({
    url: "/api" + '/demay/ssm/staffLogin/getDynamicPsw',
    method: "post",
    data
  })
}

// 动态密码登录
export function DynamicLoginNews(data){
  return service({
    url: "/api" + '/demay/ssm/staffLogin/DynamicLoginNews',
    method: "post",
    data
  })
}

// 同步总店数据
export function totalData(params,data){
  return service({
    url: "/api" + '/demay/ssm/storePara/update1',
    method: 'post',
    params,
    data
  })
}

// 添加门店参数
export function addstorePara(params) {
  return service({
    url: "/api" + "/demay/ssm/storePara/adds",
    method: "post",
    params: params
    // data:params,
    // data:{
    //   formMap:params
    // },
    // headers: {
    //   'Content-Type': 'application/x-www-form-urlencoded'
    // },
  });
}
// 门店参数列表
export function storeParaList(params) {
  return service({
    url: "/api" + "/demay/ssm/storePara/list",
    method: "post",
    data: params
  });
} 

export function accounGivetList(params) {
  return service({
    url: "/api" + "/demay/ssm/storeAccountOutin/accounGivetList",
    method: "post",
    data: params
  });
} 

export function addCardStore(params){
  return service({
    url: "/api" + "/demay/ssm/storeAccountOutin/add",
    method: "post",
    data: params
  });
}

export function storeAccountOutin(params) {
  return service({
    url: "/api" + "/demay/ssm/storeAccountOutin/page",
    method: "post",
    data: params
  });
} 

export function updateStatu(params) {
  return service({
    url: "/api" + "/demay/ssm/storeAccountOutin/updateState",
    method: "post",
    data: params
  });
} 

// 修改门店参数
export function editstorePara(params) {
  return service({
    url: "/api" + "/demay/ssm/storePara/update",
    method: "post",
    params: params
    // headers: {
    //   "Content-Type": "application/x-www-form-urlencoded"
    // }
  });
}
export function editstoreParas(params) {
  return service({
    url: "/api" + "/demay/ssm/storePara/updates",
    method: "post",
    data: params
  });
}
// 添加员工
export function addStaff(params) {
  return service({
    url: "/api" + "/demay/ssm/staff/add",
    method: "post",
    data: params
  });
}
//角色列表
export function rolepage(params) {
  return service({
    url: "/api" + "/demay/ssm/role/page",
    method: "post",
    data: params
  });
}
//分页查询员工信息
export function staffPage(params) {
  return service({
    url: "/api" + "/demay/ssm/staff/page",
    method: "post",
    data: params
  });
}
//修改员工
export function editStaff(params) {
  return service({
    url: "/api" + "/demay/ssm/staff/update",
    method: "post",
    data: params
  });
}
//员工离职
export function leave(params) {
  return service({
    url: "/api" + "/demay/ssm/staff/leave",
    method: "post",
    data: params
  });
}
export function deactivate(params) {
  return service({
    url: "/api" + "/demay/ssm/staff/stop",
    method: "post",
    data: params
  });
}

//员工复职
export function reinstated(params) {
  return service({
    url: "/api" + "/demay/ssm/staff/reinstated",
    method: "post",
    data: params
  });
}
//查询员工明细
export function selectOne(params) {
  return service({
    url: "/api" + "/demay/ssm/staff/selectOne",
    method: "post",
    data: params
  });
}
export function selectPage(params) {
  return service({
    url: "/api" + "/demay/ssm/storeConversion/selectPage",
    method: "post",
    data: params
  });
}
export function checkHumam(params) {
  return service({
    url: "/api" + "/demay/ssm/storeConversion/check",
    method: "post",
    data: params
  });
}

// 员工月度任务
export function monthJob(params) {
  return service({
    url: "/api" + "/demay/ssm/staff/monthJob",
    method: "post",
    data: params
  });
}

// 门店员工启用 门店端-员工列表-门店员工启用
export function staffStart(params) {
  return service({
    url: "/api" + "/demay/ssm/staff/start",
    method: "post",
    data: params
  });
}

//员工作品添加
export function addstWorks(params) {
  return service({
    url: "/api" + "/demay/ssm/stWorks/add",
    method: "post",
    data: params,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    }
    // headers: {"Content-Type": "multipart/form-data"}
  });
}
//删除员工作品
export function delstWorks(params) {
  return service({
    url: "/api" + "/demay/ssm/stWorks/delete",
    method: "post",
    data: params
  });
}
//查询员工作品列表
export function stWorksList(params) {
  return service({
    url: "/api" + "/demay/ssm/stWorks/list",
    method: "post",
    data: params
  });
}

//项目类别添加
export function addproType(params) {
  return service({
    url: "/api" + "/demay/ssm/proType/add",
    method: "post",
    data: params
  });
}
//项目类别修改
export function editproType(params) {
  return service({
    url: "/api" + "/demay/ssm/proType/update",
    method: "post",
    data: params
  });
}
//项目类别列表
export function proTypepage(params) {
  return service({
    url: "/api" + "/demay/ssm/proType/page",
    method: "post",
    data: params
  });
}
//项目类别删除
export function delproType(params) {
  return service({
    url: "/api" + "/demay/ssm/proType/delete",
    method: "post",
    data: params
  });
}
//项目类别状态
export function proTypeStates(params) {
  return service({
    url: "/api" + "/demay/ssm/proType/updateStates",
    method: "post",
    data: params
  });
}

//项目添加
export function addpro(params) {
  return service({
    url: "/api" + "/demay/ssm/pro/add",
    method: "post",
    data: params
  });
}

//查询项目类别列表
export function proTypeList(params) {
  return service({
    url: "/api" + "/demay/ssm/proType/list",
    method: "post",
    data: params
  });
}
//项目修改
export function editpro(params) {
  return service({
    url: "/api" + "/demay/ssm/pro/update",
    method: "post",
    data: params
  });
}
//项目列表
export function propage(params) {
  return service({
    url: "/api" + "/demay/ssm/pro/page",
    method: "post",
    data: params
  });
}
export function propageNew(params) {
  return service({
    url: "/api" + "/demay/ssm/pro/selectPageNew",
    method: "post",
    data: params
  });
}
//查询开疗程时人员
export function selectRatioInfo(params) {
  return service({
    url: "/api" + "/demay/ssm/staff/selectRatioInfo",
    method: "post",
    data: params
  });
}

export function selectRatioInfo1(params) {
  return service({
    url: "/api" + "/demay/ssm/pro/copyProject",
    method: "post",
    data: params
  });
}

//项目删除
export function delpro(params) {
  return service({
    url: "/api" + "/demay/ssm/pro/delete",
    method: "post",
    data: params
  });
}
//项目状态
export function proStates(params) {
  return service({
    url: "/api" + "/demay/ssm/pro/updateStates",
    method: "post",
    data: params
  });
}
//设置项目业绩提成
export function setAchiComm(params) {
  return service({
    url: "/api" + "/demay/ssm/pro/setAchiComm",
    method: "post",
    data: params
  });
}

//充值类别添加
export function addrecType(params) {
  return service({
    url: "/api" + "/demay/ssm/recType/add",
    method: "post",
    data: params
  });
}
//充值类别添加(升级级)
export function addrecTypess(params) {
  return service({
    url: "/api" + "/demay/ssm/recType/addss",
    method: "post",
    data: params
  });
}
//充值类别列表
export function recTypePage(params) {
  return service({
    url: "/api" + "/demay/ssm/recType/page",
    method: "post",
    data: params
  });
}
//充值类别列表(升降级)
export function recTypeSjianjiList(params) {
  return service({
    url: "/api" + "/demay/ssm/recType/sjianjiList",
    method: "post",
    data: params
  });
}
//充值类别列表(升降级)
export function recTypeSjianjiLists(params) {
  return service({
    url: "/api" + "/demay/ssm/recType/sjianjiLists",
    method: "post",
    data: params
  });
}
//充值类别列表(升级级)
export function recTypePagess(params) {
  return service({
    url: "/api" + "/demay/ssm/recType/pagess",
    method: "post",
    data: params
  });
}
//充值类别修改
export function editrecType(params) {
  return service({
    url: "/api" + "/demay/ssm/recType/update",
    method: "post",
    data: params
  });
}
//充值类别修改(升级级)
export function editrecTypes(params) {
  return service({
    url: "/api" + "/demay/ssm/recType/updates",
    method: "post",
    data: params
  });
}
//充值类别删除
export function delrecType(params) {
  return service({
    url: "/api" + "/demay/ssm/recType/delete",
    method: "post",
    data: params
  });
}
//充值类别删除(升级级)
export function delrecTypes(params) {
  return service({
    url: "/api" + "/demay/ssm/recType/deletes",
    method: "post",
    data: params
  });
}
//充值类别状态
export function recTypeStates(params) {
  return service({
    url: "/api" + "/demay/ssm/recType/updateStates",
    method: "post",
    data: params
  });
}

//平台会员添加
// export function addmember(params) {
//   return service({
//     url: "/api"+"/demay/ssm/member/add",
//     method: "post",
//     data:params,
//   });
// }
//查询单个会员信息
export function memberone(params) {
  return service({
    url: "/api" + "/demay/ssm/member/one",
    method: "post",
    data: params
  });
}
//分页查询平台会员信息
export function memberpage(params) {
  return service({
    url: "/api" + "/demay/ssm/member/page",
    method: "post",
    data: params
  });
}
//平台会员修改
export function editmember(params) {
  return service({
    url: "/api" + "/demay/ssm/member/update",
    method: "post",
    data: params
  });
}

// 重算会员等级
export function resetClass(params) {
  return service({
    url: "/api" + "/demay/ssm/storeMember/resetClass",
    method: "post",
    data: params
  });
}
// 会员换号启用 (门店端-会员-会员换号启用)
export function changePhoneToUpdateState(params) {
  return service({
    url: "/api" + "/demay/ssm/storeMember/changePhoneToUpdateState",
    method: "post",
    data: params,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    }
  });
}

// 门店会员启用时一个启用 同手机号的另一个停用 门店端-会员激活-门店会员启用时一个启用 同手机号的另一个停用
export function bothOperation(params) {
  return service({
    url: "/api" + "/demay/ssm/storeMember/bothOperation",
    method: "post",
    data: params
  });
}
// 门店会员启用 门店端-会员激活-门店会员启用
export function storeMemberStart(params) {
  return service({
    url: "/api" + "/demay/ssm/storeMember/start",
    method: "post",
    data: params
  });
}

// 分页查询门店会员修改手机号 换号激活记录 门店端-会员激活-分页查询门店会员修改手机号 换号激活记录
export function storeMemberPhonePage(params) {
  return service({
    url: "/api" + "/demay/ssm/storeMember/phonePage",
    method: "post",
    data: params
  });
}

// 门店会员激活记录 文件查询 门店端-会员激活-门店会员激活记录 文件查询
export function selectFile(params) {
  return service({
    url: "/api" + "/demay/ssm/storeMember/selectFile",
    method: "post",
    data: params
  });
}
// 通过手机号和密码查询会员所属门店 门店端-通过手机号和密码查询会员所属门店
export function storeMemberList(params) {
  return service({
    url: "/api" + "/demay/ssm/storeMember/list",
    method: "post",
    data: params
  });
}

// 平台会员分派
export function storeMemberassign(params) {
  return service({
    url: "/api" + "/demay/ssm/storeMember/assign",
    method: "post",
    data: params
  });
}
// 查询员工跟进的会员明细list
export function storeMemberlistByStaff(params) {
  return service({
    url: "/api" + "/demay/ssm/storeMember/listByStaff",
    method: "post",
    data: params
  });
}
// 分页查询门店会员信息
export function storeMemberpage(params) {
  return service({
    url: "/api" + "/demay/ssm/storeMember/page",
    method: "post",
    data: params
  });
}
export function storeMemberpages(params) {
  return service({
    url: "/api" + "/demay/ssm/storeMember/selectListNew",
    method: "post",
    data: params
  });
}
export function pageassign(params) {
  return service({
    url: "/api" + "/demay/ssm/storeMember/pageassign",
    method: "post",
    data: params
  });
}
// 门店会员停用启用
export function storeMemberupdateState(params) {
  return service({
    url: "/api" + "/demay/ssm/storeMember/updateState",
    method: "post",
    data: params
  });
}

// 员工跟进会员统计信息
export function staffMemberPage(params) {
  return service({
    url: "/api" + "/demay/ssm/staff/staffMemberPage",
    method: "post",
    data: params
  });
}

// 门店项目模板下载 门店端-项目列表-门店项目模板下载
export function proDownload(params) {
  return service({
    url: "/api" + "/demay/ssm/pro/download",
    method: "post",
    data: params,
    responseType: "blob"
  });
}
// 门店项目批量导出 门店端-项目列表-门店项目批量导出
export function proExport(params) {
  return service({
    url: "/api" + "/demay/ssm/pro/export",
    method: "post",
    data: params,
    responseType: "blob"
  });
}
// 门店项目批量导入 门店端-员工列表-门店项目批量导入
export function proImport(params) {
  return service({
    url: "/api" + "/demay/ssm/pro/import",
    method: "post",
    data: params,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    }
  });
}

// 门店员工模板下载 门店端-员工列表-门店员工模板下载
export function staffDownload(params) {
  return service({
    url: "/api" + "/demay/ssm/staff/download",
    method: "post",
    data: params,
    responseType: "blob"
  });
}

// 门店员工批量导出 门店端-员工列表-门店员工批量导出
export function staffExport(params) {
  return service({
    url: "/api" + "/demay/ssm/staff/export",
    method: "post",
    data: params,
    responseType: "blob"
  });
}
// 门店员工批量导入 门店端-员工列表-门店员工批量导入
export function staffImport(params) {
  return service({
    url: "/api" + "/demay/ssm/staff/import",
    method: "post",
    data: params,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    }
  });
}

// 门店项目类别模板下载 门店端-项目类别列表-门店项目类别模板下载
export function proTypeDownload(params) {
  return service({
    url: "/api" + "/demay/ssm/proType/download",
    method: "post",
    data: params,
    responseType: "blob"
  });
}
// 门店项目类别批量导出 门店端-项目类别列表-门店项目类别批量导出
export function proTypeExport(params) {
  return service({
    url: "/api" + "/demay/ssm/proType/export",
    method: "post",
    data: params,
    responseType: "blob"
  });
}
// 门店项目类别批量导入 门店端-项目类别列表-门店项目类别批量导入
export function proTypeImport(params) {
  return service({
    url: "/api" + "/demay/ssm/proType/import",
    method: "post",
    data: params,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    }
  });
}
// 门店充值类别模板下载 门店端-充值类别列表-门店充值类别模板下载
export function recTypeDownload(params) {
  return service({
    url: "/api" + "/demay/ssm/recType/download",
    method: "post",
    data: params,
    responseType: "blob"
  });
}
export function recTypeDownloads(params) {
  return service({
    url: "/api" + "/demay/ssm/recType/downloads",
    method: "post",
    data: params,
    responseType: "blob"
  });
}
// 门店充值类别批量导出 门店端-充值类别列表-门店充值类别批量导出
export function recTypeExport(params) {
  return service({
    url: "/api" + "/demay/ssm/recType/export",
    method: "post",
    data: params,
    responseType: "blob"
  });
}
export function recTypeExports(params) {
  return service({
    url: "/api" + "/demay/ssm/recType/exports",
    method: "post",
    data: params,
    responseType: "blob"
  });
}
// 门店充值类别批量导入 门店端-充值类别列表-门店充值类别批量导入
export function recTypeImport(params) {
  return service({
    url: "/api" + "/demay/ssm/recType/import",
    method: "post",
    data: params,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    }
  });
}
export function recTypeImports(params) {
  return service({
    url: "/api" + "/demay/ssm/recType/imports",
    method: "post",
    data: params,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    }
  });
}
// 门店会员列表模板下载 门店端-会员列表列表-门店会员列表模板下载
export function storeMemberDownload(params) {
  return service({
    url: "/api" + "/demay/ssm/storeMember/download",
    method: "post",
    data: params,
    responseType: "blob"
  });
}
// 门店会员列表批量导出 门店端-会员列表列表-门店会员列表批量导出
export function storeMemberExport(params) {
  return service({
    url: "/api" + "/demay/ssm/storeMember/export",
    method: "post",
    data: params,
    responseType: "blob"
  });
}
//获取导出验证手机号
export function authCode(params) {
  return service({
    url: "/api" + "/demay/ssm/storeMember/authCode",
    method: "post",
    data: params
  });
}
//给对应手机号发送验证码
export function authCodes(params) {
  return service({
    url: "/api" + "/demay/ssm/storeMember/authCodes",
    method: "post",
    data: params
  });
}
// 门店会员列表批量导入 门店端-会员列表列表-门店会员列表批量导入
export function storeMemberImport(params) {
  return service({
    url: "/api" + "/demay/ssm/storeMember/import",
    method: "post",
    data: params,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    }
  });
}

// 当前门店所有的门店(含本店)
export function organization(params) {
  return service({
    url: "/api" + "/demay/ssm/store/organization",
    method: "post",
    data: params
  });
}
// 当前门店所有的门店除了本店
export function organizations(params) {
  return service({
    url: "/api" + "/demay/ssm/store/pagesorganizations",
    method: "post",
    data: params
  });
}
//复制其他门店项目
export function importProject(params) {
  return service({
    url: "/api" + "/demay/ssm/pro/importProject",
    method: "post",
    data: params
  });
}

// 分页查询充值类别 门店端-充值类别-分页查询充值类别(只查询折扣卡和赠送卡)
export function recTypeNewPage(params) {
  return service({
    url: "/api" + "/demay/ssm/recType/newpage",
    method: "post",
    data: params
  });
}
export function recTypeNewPages(params) {
  return service({
    url: "/api" + "/demay/ssm/recType/newpages",
    method: "post",
    data: params
  });
}

// 添加可升降级卡
export function recTypetoadd(params) {
  return service({
    url: "/api" + "/demay/ssm/rechargedemotioneingrun/add",
    method: "post",
    data: params
  });
}

// 分页获取可升降级卡
export function recTypetopage(params) {
  return service({
    url: "/api" + "/demay/ssm/rechargedemotioneingrun/page",
    method: "post",
    data: params
  });
}

// 分页本店全部升降级关系信息
export function recTypetopages(params) {
  return service({
    url: "/api" + "/demay/ssm/rechargedemotioneingrun/pages",
    method: "post",
    data: params
  });
}

// 修改可升降级卡
export function recTypetoedit(params) {
  return service({
    url: "/api" + "/demay/ssm/rechargedemotioneingrun/update",
    method: "post",
    data: params
  });
}
// 修改可升降级卡
export function recTypetodel(params) {
  return service({
    url: "/api" + "/demay/ssm/rechargedemotioneingrun/del",
    method: "post",
    data: params
  });
}

// 修改升降级卡状态
export function recTypetoupdateStatus(params) {
  return service({
    url: "/api" + "/demay/ssm/rechargedemotioneingrun/updateStatus",
    method: "post",
    data: params
  });
}
// 项目拷贝业绩提成 门店端-项目-项目设置业绩提成
export function setAchiCommList(params) {
  return service({
    url: "/api" + "/demay/ssm/pro/setAchiCommList",
    method: "post",
    data: params
  });
}

// 查询高管业绩
export function salesman(params) {
  return service({
    url: "/api" + "/demay/ssm/salesman/selectList",
    method: "post",
    data: params
  });
}
// 查询高管业绩
export function salesmans(params) {
  return service({
    url: "/api" + "/demay/ssm/salesman/selectLists",
    method: "post",
    data: params
  });
}
// 查询高管业绩明细
export function salesmanMx(params) {
  return service({
    url: "/api" + "/demay/ssm/salesman/selectListMx",
    method: "post",
    data: params
  });
}
// 查询高管业绩明细
export function salesmanMxs(params) {
  return service({
    url: "/api" + "/demay/ssm/salesman/selectListMxs",
    method: "post",
    data: params
  });
}
// 查询高管业绩明细导出
export function salesmanExportachi(params) {
  return service({
    url: "/api" + "/demay/ssm/salesman/selectLists/export",
    method: "post",
    responseType: "blob",
    data: params
  });
}
export function exportachiMX(params) {
  return service({
    url: "/api" + "/demay/ssm/salesman/exportachiMX",
    method: "post",
    responseType: "blob",
    data: params
  });
}
//导出高管明细单据
export function exportachiMXwhole(params) {
  return service({
    url: "/api" + "/demay/ssm/salesman/exportachiMXwhole",
    method: "post",
    responseType: "blob",
    data: params
  });
}
//管理层业绩导出
export function salesmanExportachis(params) {
  return service({
    url: "/api" + "/demay/ssm/salesman/exportachis",
    method: "post",
    responseType: "blob",
    data: params
  });
}
export function exportachiMXs(params) {
  return service({
    url: "/api" + "/demay/ssm/salesman/exportachiMXs",
    method: "post",
    responseType: "blob",
    data: params
  });
}
//导出管理层全部明细
export function exportachiMXswhole(params) {
  return service({
    url: "/api" + "/demay/ssm/salesman/exportachiMXswhole",
    method: "post",
    responseType: "blob",
    data: params
  });
}

// 查询项目类别树
export function queryTree(params) {
  return service({
    url: "/api" + "/demay/ssm/proType/queryTree",
    method: "post",
    data: params
  });
}

// 查询总店门店参数
export function pagesorganizationone(params) {
  return service({
    url: "/api" + "/demay/ssm/store/pagesorganizationone",
    method: "post",
    data: params
  });
}

// 添加门店员工转店申请
export function addStoreConversion(params) {
  return service({
    url: "/api" + "/demay/ssm/storeConversion/add",
    method: "post",
    data: params
  });
}

// 添加门店员工转店申请（状态修改）
export function editStateStoreConversion(params) {
  return service({
    url: "/api" + "/demay/ssm/storeConversion/updateStatu",
    method: "post",
    data: params
  });
}

export function editStateStoreConversions(params) {
  return service({
    url: "/api" + "/demay/ssm/storeConversion/updateStatu2",
    method: "post",
    data: params
  });
}
// 添加门店员工转店申请查询
export function storeConversionPage(params) {
  return service({
    url: "/api" + "/demay/ssm/storeConversion/page",
    method: "post",
    data: params
  });
}

// 添加门店会员疗程转店申请
export function addStoreTurnTreatment(params) {
  return service({
    url: "/api" + "/demay/ssm/storeTurnTreatment/add",
    method: "post",
    data: params
  });
}

// 添加门店会员疗程转店申请（状态修改）
export function editStateStoreTurnTreatment(params) {
  return service({
    url: "/api" + "/demay/ssm/storeTurnTreatment/updateStatu",
    method: "post",
    data: params
  });
}

// 添加门店会员疗程转店申请查询
export function storeTurnTreatmentPage(params) {
  return service({
    url: "/api" + "/demay/ssm/storeTurnTreatment/page",
    method: "post",
    data: params
  });
}
//修改会员登录密码
export function passwordReset(params) {
  return service({
    url: "/api" + "/demay/ssm/storeMember/passwordReset",
    method: "post",
    data: params
  });
}
//修改会员支付密码
export function cashPasswordReset(params) {
  return service({
    url: "/api" + "/demay/ssm/storeMember/cashPasswordReset",
    method: "post",
    data: params
  });
}

// 添加房间
export function addRoom(params) {
  return service({
    url: "/api" + "/demay/ssm/storeRoom/add",
    method: "post",
    data: params
  });
}

// 查询房间
export function roomPage(params) {
  return service({
    url: "/api" + "/demay/ssm/storeRoom/page",
    method: "post",
    data: params
  });
}
// 查询房间带手牌动态
export function roomPages(params) {
  return service({
    url: "/api" + "/demay/ssm/storeRoom/pages",
    method: "post",
    data: params
  });
}
// 修改房间
export function editRoom(params) {
  return service({
    url: "/api" + "/demay/ssm/storeRoom/update",
    method: "post",
    data: params
  });
}

// 修改启用禁用
export function editStateRoom(params) {
  return service({
    url: "/api" + "/demay/ssm/storeRoom/updateStates",
    method: "post",
    data: params
  });
}

//部门业绩
export function departmentPerformance(params) {
  return service({
    url: "/api" + "/demay/ssm/staff/departmentPerformance",
    method: "post",
    data: params
  });
}

// 导出部门业绩
export function exportachi(params) {
  return service({
    url: "/api" + "/demay/ssm/staff/departmentPerformance/exportachi",
    method: "post",
    data: params,
    responseType: "blob",
  });
}

//明细
export function departmentPerformance2(params) {
  return service({
    url: "/api" + "/demay/ssm/staff/departmentPerformance2",
    method: "post",
    data: params
  });
}
export function departmentPerformance3(params) {
  return service({
    url: "/api" + "/demay/ssm/staff/departmentPerformance3",
    method: "post",
    data: params
  });
}

// 会员卡包转送申请单
export function addTurnMembershipCard(params) {
  return service({
    url: "/api" + "/demay/ssm/turnMembershipCard/add",
    method: "post",
    data: params
  });
}
export function addTurnMembershipCardNew(params) {
  return service({
    url: "/api" + "/demay/ssm/turnMembershipCard/addNew",
    method: "post",
    data: params
  });
}

// 修改会员卡包转送申请单
export function editTurnMembershipCard(params) {
  return service({
    url: "/api" + "/demay/ssm/turnMembershipCard/update",
    method: "post",
    data: params
  });
}
export function editTurnMembershipCardNew(params) {
  return service({
    url: "/api" + "/demay/ssm/turnMembershipCard/updateNew",
    method: "post",
    data: params
  });
}
// 查询会员转卡申请单
export function turnMembershipCardPage(params) {
  return service({
    url: "/api" + "/demay/ssm/turnMembershipCard/page",
    method: "post",
    data: params
  });
}

// 会员卡包转送申请单状态修改
export function stateTurnMembershipCard(params) {
  return service({
    url: "/api" + "/demay/ssm/turnMembershipCard/updateState",
    method: "post",
    data: params
  });
}
export function stateTurnMembershipCardNew(params) {
  return service({
    url: "/api" + "/demay/ssm/turnMembershipCard/updateStateNew",
    method: "post",
    data: params
  });
}
// 添加等级
export function addMemberClass(params) {
  return service({
    url: "/api" + "/demay/ssm/StoreMemberClass/add",
    method: "post",
    data: params
  });
}

// 删除
export function delMemberClass(params) {
  return service({
    url: "/api" + "/demay/ssm/StoreMemberClass/delete",
    method: "post",
    data: params
  });
}

// 查询房间
export function pageMemberClass(params) {
  return service({
    url: "/api" + "/demay/ssm/StoreMemberClass/page",
    method: "post",
    data: params
  });
}

// 修改等级
export function editMemberClass(params) {
  return service({
    url: "/api" + "/demay/ssm/StoreMemberClass/updates",
    method: "post",
    data: params
  });
}

// 添加职务
export function addBasePost(params) {
  return service({
    url: "/api" + "/demay/ssm/BasePost/add",
    method: "post",
    data: params
  });
}

// 查询职务
export function pageBasePost(params) {
  return service({
    url: "/api" + "/demay/ssm/BasePost/page",
    method: "post",
    data: params
  });
}

// 修改职务
export function editBasePost(params) {
  return service({
    url: "/api" + "/demay/ssm/BasePost/update",
    method: "post",
    data: params
  });
}

// 分派本店项目到其他门店
export function assignProject(params) {
  return service({
    url: "/api" + "/demay/ssm/pro/assignProject",
    method: "post",
    data: params
  });
}
// 添加工种(只能总店操作)
export function addBaseWorkType(params) {
  return service({
    url: "/api" + "/demay/ssm/BaseWorkType/add",
    method: "post",
    data: params
  });
}

// 删除工种(只能总店操作)
export function deleteBaseWorkType(params) {
  return service({
    url: "/api" + "/demay/ssm/BaseWorkType/delete",
    method: "post",
    data: params
  });
}

// 查询工种
export function pageBaseWorkType(params) {
  return service({
    url: "/api" + "/demay/ssm/BaseWorkType/page",
    method: "post",
    data: params
  });
}

// 添加工种(只能总店操作)
export function updateBaseWorkType(params) {
  return service({
    url: "/api" + "/demay/ssm/BaseWorkType/update",
    method: "post",
    data: params
  });
}

// 启用和停用工种(只能总店操作)
export function updateStateBaseWorkType(params) {
  return service({
    url: "/api" + "/demay/ssm/BaseWorkType/updateState",
    method: "post",
    data: params
  });
}

// 添加角色 门店端-角色-添加角色
export function roleAdd(params) {
  return service({
    url: "/api" + "/demay/ssm/SysStoreRole/add",
    method: "post",
    data: params
  });
}

// 添加角色关联菜单列表 门店端-角色
export function roleAddMuenRole(params) {
  return service({
    url: "/api" + "/demay/ssm/SysStoreRole/addMuenRole",
    method: "post",
    data: params
  });
}

// 添加角色关联门店列表 门店端-角色
export function roleAddRoleStore(params) {
  return service({
    url: "/api" + "/demay/ssm/SysStoreRole/addRoleStore",
    method: "post",
    data: params
  });
}

// 分页获取角色信息 门店端-角色-分页获取角色信息
export function rolePage(params) {
  return service({
    url: "/api" + "/demay/ssm/SysStoreRole/page",
    method: "post",
    data: params
  });
}

// 修改角色 门店端-角色-修改角色
export function roleEdit(params) {
  return service({
    url: "/api" + "/demay/ssm/SysStoreRole/update",
    method: "post",
    data: params
  });
}

// 修改角色状态 门店端-角色-修改角色状态
export function roleEditState(params) {
  return service({
    url: "/api" + "/demay/ssm/SysStoreRole/updateState",
    method: "post",
    data: params
  });
}

// 分页获取角色信息 门店端 - 角色 - 分页获取角色信息
export function roleStorePage(params) {
  return service({
    url: "/api" + "/demay/ssm/SysRoleStore/page",
    method: "post",
    data: params
  });
}

// 分页获取角色菜单信息 门店端-角色-分页获取角色信息
export function roleMuenPage(params) {
  return service({
    url: "/api" + "/demay/ssm/SysMuenRole/newPage",
    method: "post",
    data: params
  });
}
//菜单权限
export function rolepower(params) {
  return service({
    url: "/api" + "/demay/ssm/menupower/list",
    method: "post",
    data: params
  });
}
// ================================================= 微信公众号 ================================================= //
// 查询设置的微信公众号
export function getWXAccount(params) {
  return service({
    url: "/api" + "/storeWechat",
    method: "get",
    params
  });
}
// 设置微信公众号
export function doSetWXAccount(data) {
  return service({
    url: "/api" + "/storeWechat/add",
    method: "post",
    data
  });
}
// 修改微信公众号
export function doEditWXAccount(data) {
  return service({
    url: "/api" + "/storeWechat",
    method: "put",
    data
  });
}

// 疗程报表导出
export function groupCourse(params) {
  return service({
    url: "/api" + "/demay/ssm/course/groupCourse",
    method: "post",
    data: params,
    responseType:'blob'
  });
}



// WEBPACK FOOTER //
// ./src/api/storeManage.js